// 放在前面的路由
export const routes = [
  // {
  //   path: '/404',
  //   component: () => import('@/pages/404'),
  //   hidden: true,
  //   meta: { title: '404' },
  // },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/404',
  //   hidden: true,
  //   meta: {
  //     sort: 101
  //   }
  // }
]

export default routes

